import { Injectable } from '@angular/core';
import { FetchHelper } from '../../../../core/helpers/fetch-helper';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  async GetAllNotifications() {
    return await FetchHelper.get('/system/Notification/GetAllNotifications')
  }

  async ReadNotification(id: number) {
    return await FetchHelper.get('/system/Notification/Reading', { id })
  }
}
